import type { Brand } from '@seek/melways-sites';

import getClient from '../../modules/graphql/getClient';
import GET_JOB from '../../modules/graphql/getJob';
import type { JobPayload } from '../../modules/graphql/types';
import type { ApplyContext, Environment } from '../../types';
import { logError } from '../datadog';

const getJobDetails = async (
  environment: Environment,
  jobId: string,
  locale: string,
  brand: Brand = 'seek',
): Promise<ApplyContext | null> => {
  try {
    const client = getClient(environment, { locale, brand });
    const { data } = await client.query<{ jobDetails: { job: JobPayload } }>({
      query: GET_JOB,
      variables: {
        jobId,
      },
    });
    const result: ApplyContext = {
      title: data.jobDetails.job.title,
      advertiser: data.jobDetails.job.advertiser.name,
    };

    return result;
  } catch (err) {
    logError(err, `could not retrieve job: ${jobId}`);

    return null;
  }
};

export default getJobDetails;
